import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnlineTaskInspectionComponent } from './online-task-inspection.component';
import { OnlineTaskInspectionGuard } from '../shared/guard/online-task-inspection.guard';

const routes: Routes = [
  {
    path: '',
    component: OnlineTaskInspectionComponent,
    children: [
      {
        path: '',
        redirectTo: 'find-vehicle-claim',
        pathMatch: 'full',
      },

      // Backward compatibility redirects
      {
        path: 'find-task',
        redirectTo: 'find-vehicle-claim',
        pathMatch: 'full',
      },

      // Primary routes
      {
        path: 'find-vehicle-claim',
        loadChildren: () =>
          import('./find-vehicle-claim/find-vehicle-claim.module').then(
            (m) => m.FindVehicleClaimModule
          ),
        pathMatch: 'full',
      },
      {
        path: 'find-claim',
        loadChildren: () =>
          import('./find-claim/find-claim.module').then(
            (m) => m.FindClaimModule
          ),
        pathMatch: 'full',
      },
      {
        path: 'thanks',
        loadChildren: () =>
          import('./thanks/thanks.module').then((m) => m.ThanksModule),
        pathMatch: 'full',
      },

      {
        path: ':token',
        loadChildren: () =>
          import(
            './online-task-inspection-detail/online-task-inspection-detail.module'
            ).then((m) => m.OnlineTaskInspectionDetailModule),
        canActivate: [OnlineTaskInspectionGuard],
      },

      {
        path: '**',
        redirectTo: 'not-found'
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OnlineTaskInspectionRoutingModule {}
